import { Injectable } from '@angular/core';
import { Observable, of, ReplaySubject, switchMap, tap } from 'rxjs';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { Rating } from '../../interfaces/route-planning/rating.interface';
import { RatingRepository } from '../../repositories/rating.repository';
import { LocalStorageService } from 'src/app/@shared/services/local-storage/local-storage.service';

export type Ratings = {
  [entityId: string]: number;
};

@Injectable({
  providedIn: 'root',
})
export class RatingService {
  private static readonly RATING_STORAGE_KEY = 'ratings';

  private _ratings: Ratings;

  onRatingsChange$ = new ReplaySubject<Ratings>();

  constructor(
    private readonly ratingRepository: RatingRepository,
    private readonly localStorageService: LocalStorageService
  ) {
    this._ratings =
      this.localStorageService.getNestedItem<Ratings>(
        RatingService.RATING_STORAGE_KEY
      ) ?? {};
  }

  public get ratings(): Ratings {
    return this._ratings;
  }
  public set ratings(value: Ratings) {
    this._ratings = value;
    this.onRatingsChange$.next(this._ratings);
  }

  addRating(body: {
    sessionId: string;
    entityId: string;
    rating: number;
    type: number;
  }): Observable<ServiceResponse<Rating>> {
    if (!body?.rating)
      return of(null);

    return this.ratingRepository
      .addRating(body)
      .pipe(tap(() => this.saveRatingInStorage(body.entityId, body.rating)));
  }

  saveRatingInStorage(entityId: any, rating: number): void {
    this.ratings[entityId] = rating;
    this.localStorageService.setItem(RatingService.RATING_STORAGE_KEY, this.ratings);
  }
}
